"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KpiRenderer = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var internal_1 = require("../../../internal");
/**
 * @internal
 */
exports.KpiRenderer = function (_a) {
    var disableDrillUnderline = _a.disableDrillUnderline, onDrill = _a.onDrill, isDrillable = _a.isDrillable, kpi = _a.kpi, kpiResult = _a.kpiResult, filters = _a.filters, separators = _a.separators, enableCompactSize = _a.enableCompactSize;
    var onPrimaryValueClick = react_1.useCallback(function () {
        var _a;
        if (!isDrillable || !onDrill) {
            return;
        }
        return onDrill({
            type: "headline",
            element: "primaryValue",
            value: (_a = kpiResult.measureResult) === null || _a === void 0 ? void 0 : _a.toString(),
            intersection: [
                {
                    header: kpiResult.measureDescriptor,
                },
            ],
        });
    }, [kpiResult === null || kpiResult === void 0 ? void 0 : kpiResult.measureResult, kpiResult === null || kpiResult === void 0 ? void 0 : kpiResult.measureDescriptor, isDrillable, onDrill]);
    return (react_1.default.createElement(internal_1.KpiContent, { isLoading: false, kpi: kpi, kpiResult: kpiResult, isKpiUnderlineHiddenWhenClickable: disableDrillUnderline, onKpiValueClick: isDrillable && onDrill && onPrimaryValueClick, filters: filters, separators: separators, enableCompactSize: enableCompactSize }));
};
//# sourceMappingURL=KpiRenderer.js.map